var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"live-away"},[_c('div',{staticClass:"live-away-txt"},[_vm._v("Wait a moment please ~")])])
}]

export { render, staticRenderFns }